var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-box" },
    [
      _c("div", { staticClass: "v-height-flag" }, [
        _c(
          "div",
          { staticClass: "clearfix el-card__header" },
          [
            _c("el-input", {
              attrs: {
                placeholder: _vm.$t("public.searchdepartment"),
                clearable: "",
                size: "small",
                "suffix-icon": "el-icon-search",
              },
              model: {
                value: _vm.filterText,
                callback: function ($$v) {
                  _vm.filterText = $$v
                },
                expression: "filterText",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { directives: [{ name: "height", rawName: "v-height" }] },
          [
            _c("el-scrollbar", { staticStyle: { height: "100%" } }, [
              _c(
                "div",
                { staticClass: "tree-box-con" },
                [
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      data: _vm.parentTree,
                      "default-expanded-keys": _vm.defaultFrame,
                      "expand-on-click-node": false,
                      "filter-node-method": _vm.filterNode,
                      "highlight-current": true,
                      props: _vm.defaultProps,
                      "node-key": "value",
                    },
                    on: { "node-click": _vm.handleClick },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var node = ref.node
                          var data = ref.data
                          return _c(
                            "div",
                            { staticClass: "custom-tree-node" },
                            [
                              _c("div", { staticClass: "flex-box" }, [
                                _c("i", {
                                  staticClass:
                                    "tree-icon iconfont iconwenjianjia",
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "over-text" }, [
                                  _vm._v(_vm._s(node.label)),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("（" + _vm._s(data.user_count) + "）"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        ref: "pop-" + data.value,
                                        attrs: {
                                          offset: 10,
                                          placement: "bottom-end",
                                          trigger: "click",
                                        },
                                        on: {
                                          hide: _vm.handleHide,
                                          "after-enter": function ($event) {
                                            return _vm.handleShow(data.value)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "right-item-list" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "right-item",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.addDivsion(0)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "public.Adddepartment"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            data.pid !== 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "right-item",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.addDivsion(1)
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t("public.edit")
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            data.pid !== 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "right-item",
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        return _vm.hanleDelete(
                                                          data
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "public.delete"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "iconfont icongengduo right-icon",
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]
                          )
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("rightRole", {
        ref: "roleBox",
        attrs: {
          config: _vm.drawerConfig,
          "frame-id": _vm.frameId,
          "parent-id": _vm.parentId,
          "parent-tree": _vm.parentTree,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }